import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IMoveToCompanyPayload {
    id: string
    companyId: string
    sagaCB?: {
        onSuccess: any
        onError?: any
    }
}

export interface IListState {
    status: string
    data: any
    errors: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const moveToCompanySlice = createSlice({
    name: 'hub/contacts/move-to-company',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMoveToCompanyPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const moveToCompanyActions = moveToCompanySlice.actions
export default moveToCompanySlice.reducer
